import React from 'react';
import PropTypes from 'prop-types';
import MainTitle from 'base/components/MainTitle/index';
import { closeModal } from 'modal/store/actions';
import { useGetContactQuery, useUpdateContactMutation } from 'contacts/store/contactService';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import Loader from 'base/components/Loader';
import toast from 'base/components/Toast/toast';
import { getActiveContactId } from '../../store/selectors';
import ContactForm from './ContactForm';

export default function UpdateContactModal({ name }) {
  const dispatch = useAppDispatch();
  const activeContactId = useAppSelector(getActiveContactId);
  const { data: contact, isLoading } = useGetContactQuery(activeContactId);
  const [updateContact] = useUpdateContactMutation();
  return (
    <>
      <MainTitle withSpaceBelow>Edit Contact</MainTitle>
      <Loader isLoading={isLoading}>
        <ContactForm
          contact={contact}
          isAdminForm
          onSubmit={async contactValues => {
            try {
              const updatedContact = {
                ...contact,
                ...contactValues,
              };
              await updateContact({
                contact: updatedContact,
                image: contactValues?.imageFile[0]?.fileObject || null,
              }).unwrap();
              toast.success('Successfully updated contact');
              dispatch(closeModal(name));
            } catch (error) {
              toast.error('Error updating contact');
            }
          }}
        />
      </Loader>
    </>
  );
}
UpdateContactModal.propTypes = {
  name: PropTypes.string.isRequired,
};
